export default __webpack_public_path__ + "static/media/Coorest_C01.21af71b2.mp4";